import axios from "fetch-api/fetch-api";
import { IVehicles } from "../interfaces/garage-apis";

export function getVehiclesFromBrowserState() : Promise<IVehicles> {
  return new Promise((resolve, reject) => {
    axios.post<IVehicles>("/get-vehicles-v4")
      .then(({ data }) => {
        resolve(data);
      }).catch((e: any) => reject(e));
  });
}
